import { render, staticRenderFns } from "./RedesignTooltip.vue?vue&type=template&id=50496784"
import script from "./RedesignTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignTooltip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignTooltip.vue?vue&type=style&index=0&id=50496784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports